module.exports = __webpack_public_path__ + "img/5.e7375fce.png";